/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect } from "react";
import Box from "src/components/shared/atoms/box";
import Typography from "@mui/material/Typography";
import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as GoogleSvgComponent } from "src/assets/images/auth/Google.svg";
import { ReactComponent as FacebookSvgComponent } from "src/assets/images/auth/Facebook.svg";
import { ReactComponent as InstagramSvgComponent } from "src/assets/images/auth/Instagram.svg";
import { useMutation } from "@apollo/client";
import expressConfig from "src/config/express.json";
import { FacebookFunc } from "src/utils/auth/Facebook";
import FACEBOOKBUSINESSLOGIN from "src/graphql/mutation/auth/facebookbuisnesslogin";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { getStoredUtmParams } from "src/utils/utmTracker";
import useStyles from "./Styles";

interface Props {
  type: string;
}
declare global {
  interface Window {
    FB: any;
  }
}

const SocialLoginButton: React.FC<Props> = ({ type }) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  useEffect(() => {
    FacebookFunc.fbInt();
  }, []);
  const [facebookBuisnessLogin, { data: facebookBuisnessLoginResult }] =
    useMutation(FACEBOOKBUSINESSLOGIN);
  const buttonDetails = () => {
    const env =
      process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";
    const config = expressConfig[env as keyof typeof expressConfig];
    // 3. Facebook login with JavaScript SDK

    const {
      auth_url,
      INSTAGRAM_CLIENT_ID,
      graphql_domain,
    }: {
      auth_url: string;
      INSTAGRAM_CLIENT_ID: string;
      graphql_domain: string;
    } = config;
    let icon;
    let text;
    let handleClick;
    if (type === "google") {
      icon = <GoogleSvgComponent />;
      text = "Sign In with Google";
      handleClick = () => {
        window.open(`${auth_url}google`, "_self");
      };
    }

    function launchFBE() {
      window.FB.login(
        function (response: any) {
          if (response.authResponse) {
            // returns a User Access Token with scopes requested
            const { accessToken } = response.authResponse;

            // send token to backend
            const utmParams = getStoredUtmParams();
            facebookBuisnessLogin({
              variables: {
                accesstoken: accessToken,
                ...utmParams,
              },
            });
          } else {
            console.log("User cancelled login or did not fully authorize.");
          }
        },
        {
          scope: [
            "email", // to get the user’s email
            "public_profile", // to get id, name, picture
            "pages_messaging",
          ].join(","),
        },
      );
    }

    //
    if (type === "facebook") {
      icon = <FacebookSvgComponent />;
      text = "Sign In with Facebook";
      handleClick = () => {
        launchFBE();
      };
    }

    if (type === "instagram") {
      icon = <InstagramSvgComponent />;
      text = "Sign In with Instagram";

      handleClick = () => {
        const instagramAuthURL = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${INSTAGRAM_CLIENT_ID}&redirect_uri=${graphql_domain}/auth/instagram/callback&response_type=code&scope=instagram_business_basic%2Cinstagram_business_manage_messages%2Cinstagram_business_manage_comments%2Cinstagram_business_content_publish%2Cinstagram_business_manage_insights`;

        window.open(instagramAuthURL, "_self");
      };
    }

    return {
      icon,
      text,
      handleClick,
    };
  };

  useEffect(() => {
    if (
      facebookBuisnessLoginResult &&
      facebookBuisnessLoginResult.facebookBusinessLogin
    ) {
      if (facebookBuisnessLoginResult.facebookBusinessLogin.success) {
        const parsedData = JSON.parse(
          facebookBuisnessLoginResult.facebookBusinessLogin.result,
        );

        const { message, isCreated } = parsedData;

        if (isCreated)
          enqueueSnackbar(message, {
            variant: "success",
          });

        navigate("/");
      } else {
        enqueueSnackbar(
          facebookBuisnessLoginResult.facebookBusinessLogin.error,
          {
            variant: "error",
          },
        );
      }
    }
  }, [facebookBuisnessLoginResult]);

  const { icon, text, handleClick } = buttonDetails();
  return (
    <Box className={classes.root} onClick={handleClick}>
      <Box className={classes.box}>
        <SvgIcon>{icon}</SvgIcon>
      </Box>
      <Typography ml={1} className={classes.text}>
        {text}
      </Typography>
    </Box>
  );
};

export default SocialLoginButton;
